export type ApplicationFeatures = { timePermission: boolean };
let features: ApplicationFeatures = { timePermission: false };

/** Loaded from the current-user API; absent configuration fails closed. */
export function setApplicationFeatures(value: unknown): void {
  const row = value && typeof value === 'object' ? value as Record<string, unknown> : {};
  features = { timePermission: row.timePermission === true };
}
export function isTimePermissionEnabled(): boolean {
  return features.timePermission;
}
export function isTimePermissionEntity(value: unknown): boolean {
  return ['PERMISSION', 'PERMISSION_REQUEST', 'TIME_PERMISSION_REQUEST'].includes(String(value || '').toUpperCase());
}
